module.exports = __webpack_public_path__ + "static/media/hashdocs.18925572.png";